// src/components/ModalAgregarCliente.jsx
import React, { useEffect, useState } from "react";
import "./ModalAgregarCliente.css";

// TOAST
import Toast from "../components/Toast";
import { authFetch } from "../utils/authFetch";

export default function ModalAgregarCliente({ onClose, onGuardar }) {
  const [planes, setPlanes] = useState([]);
  const [nodos, setNodos] = useState([]);
  const [errorNodos, setErrorNodos] = useState("");

  const [form, setForm] = useState({
    id: "",
    nodo_id: "",
    nombre: "",
    apellidos: "",
    direccion: "", // ✅ NUEVO
    telefono: "",
    colonia: "",
    municipio: "",
    plan: "",
    costo: "",
    num_serie: "",
    pppoe_user: "",
    pppoe_pass: "",
    comentario: "",
  });

  function generarPPPoEPass() {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let extra = "";
    for (let i = 0; i < 7; i++)
      extra += chars[Math.floor(Math.random() * chars.length)];
    return "WF" + extra;
  }

  async function cargarNodos() {
    // Un desplegable vacío no dice si no hay nodos, si falló la consulta
    // o si la sesión caducó. Cada caso se arregla distinto, así que el
    // motivo se guarda y se muestra junto al campo.
    try {
      const res = await authFetch("/api/nodos/listar");
      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.ok) {
        setErrorNodos(data.mensaje || `El servidor respondió ${res.status}.`);
        return;
      }

      const lista = data.nodos || [];
      setNodos(lista);
      if (lista.length === 0) {
        setErrorNodos("No hay localidades registradas todavía.");
      } else if (lista.length === 1) {
        // Con una sola no hay nada que preguntar.
        setForm((f) => ({ ...f, nodo_id: String(lista[0].id) }));
      }
    } catch (e) {
      setErrorNodos(String(e));
    }
  }

  async function cargarPlanes() {
    try {
      const res = await authFetch("/api/planes/listar");
      const data = await res.json();
      if (data.ok) setPlanes(data.planes);
    } catch (e) {
      console.log("Error cargando planes:", e);
    }
  }

  useEffect(() => {
    cargarPlanes();
    cargarNodos();
    setForm((f) => ({ ...f, pppoe_pass: generarPPPoEPass() }));
  }, []);

  function handleChangeID(e) {
    let value = e.target.value.replace(/\D/g, "");
    const newPPPoE = value ? `user${value}` : "";

    setForm({
      ...form,
      id: value,
      pppoe_user: newPPPoE,
    });
  }

  function actualizarCampo(campo, valor) {
    setForm({ ...form, [campo]: valor });
  }

  function seleccionarPlan(valorPlan) {
    const planSel = planes.find((p) => p.nombre === valorPlan);
    setForm({
      ...form,
      plan: valorPlan,
      costo: planSel ? planSel.costo : "",
    });
  }

  const [toast, setToast] = useState(null);
  const [instalacionCosto, setInstalacionCosto] = useState(0);
  const [instalacionTipo, setInstalacionTipo] = useState("contado");
  const [instalacionMeses, setInstalacionMeses] = useState(1);

  function guardar() {
  if (!form.nodo_id) {
    setToast({ mensaje: "Elige la localidad del cliente", tipo: "error" });
    return;
  }

  if (!form.id || !form.nombre || !form.apellidos || !form.plan) {
    setToast({ mensaje: "Completa los campos obligatorios", tipo: "error" }); 
    return;
  }

  const costoInst = Number(instalacionCosto || 0);

  if (instalacionTipo === "meses" && costoInst <= 0) {
    setToast({ mensaje: "Si la instalación es a meses, el costo debe ser mayor a 0", tipo: "error" });
    return;
  }

  const payload = {
    ...form,
    instalacion: {
      costo: costoInst,
      tipo: instalacionTipo,
      meses: instalacionTipo === "contado" ? 1 : instalacionMeses,
    },
  };

  onGuardar(payload);
}

  // Los planes del nodo elegido, y solo esos. Un plan lleva la VLAN y
  // los perfiles de SU OLT: ofrecer los de la otra localidad sería
  // ofrecer una VLAN que en este nodo no existe.
  const nodo = nodos.find((n) => String(n.id) === String(form.nodo_id));
  const planesDelNodo = nodo
    ? planes.filter((p) => p.olt_id === nodo.olt_id)
    : [];

  return (
    <div className="modal-backdrop-cliente">
      <div className="modal-cliente">
        <h2>Agregar Cliente</h2>

        <div className="form-grid">
          {/* Va primero porque de él dependen los planes: el nodo decide
              qué OLT atiende al cliente, y cada OLT tiene los suyos. */}
          <select
            value={form.nodo_id}
            onChange={(e) => {
              // Al cambiar de localidad, el plan elegido deja de existir.
              setForm((f) => ({ ...f, nodo_id: e.target.value, plan: "", costo: "" }));
            }}
          >
            <option value="">Localidad…</option>
            {nodos.map((n) => (
              <option key={n.id} value={n.id}>{n.nombre}</option>
            ))}
          </select>
          {errorNodos && <small className="aviso-nodos">{errorNodos}</small>}

          <input placeholder="ID Cliente" value={form.id} onChange={handleChangeID} />

          <input placeholder="PPPoE User (auto)" value={form.pppoe_user} readOnly />

          <input
            placeholder="PPPoE Pass"
            value={form.pppoe_pass}
            onChange={(e) => actualizarCampo("pppoe_pass", e.target.value)}
          />

          <input
            placeholder="Nombre"
            value={form.nombre}
            onChange={(e) => actualizarCampo("nombre", e.target.value)}
          />

          <input
            placeholder="Apellidos"
            value={form.apellidos}
            onChange={(e) => actualizarCampo("apellidos", e.target.value)}
          />

          {/* ✅ DIRECCIÓN (NUEVO) */}
          <input
            placeholder="Dirección"
            value={form.direccion}
            onChange={(e) => actualizarCampo("direccion", e.target.value)}
          />

          <input
            placeholder="Teléfono"
            value={form.telefono}
            onChange={(e) => actualizarCampo("telefono", e.target.value)}
          />

          <input
            placeholder="Colonia"
            value={form.colonia}
            onChange={(e) => actualizarCampo("colonia", e.target.value)}
          />

          <input
            placeholder="Municipio"
            value={form.municipio}
            onChange={(e) => actualizarCampo("municipio", e.target.value)}
          />

          {/* Un desplegable vacío no dice nada. Los tres motivos por los
              que puede estarlo son distintos y se arreglan distinto. */}
          <select
            value={form.plan}
            onChange={(e) => seleccionarPlan(e.target.value)}
            disabled={!form.nodo_id || planesDelNodo.length === 0}
          >
            <option value="">
              {!form.nodo_id
                ? "Elige primero la localidad"
                : !nodo?.olt_id
                ? "Esa localidad no tiene OLT"
                : planesDelNodo.length === 0
                ? "Esa OLT todavía no tiene planes"
                : "Seleccione un plan..."}
            </option>
            {planesDelNodo.map((p) => (
              <option key={p.id} value={p.nombre}>
                {p.nombre} - ${p.costo}
              </option>
            ))}
          </select>

          <input placeholder="Costo" type="number" value={form.costo} readOnly />

          <input
            placeholder="Número de Serie ONU"
            value={form.num_serie}
            onChange={(e) => actualizarCampo("num_serie", e.target.value)}
          />
        </div>

        <textarea
          placeholder="Comentario"
          value={form.comentario}
          onChange={(e) => actualizarCampo("comentario", e.target.value)}
        />

        <h3 style={{ marginTop: "20px" }}>Instalación</h3>

        <div className="form-grid">
          <input
            type="number"
            placeholder="Costo instalación"
            value={instalacionCosto}
            onChange={(e) => setInstalacionCosto(e.target.value)}
          />

          <select value={instalacionTipo} onChange={(e) => setInstalacionTipo(e.target.value)}>
            <option value="contado">Contado</option>
            <option value="meses">Meses sin intereses</option>
          </select>

          {instalacionTipo === "meses" && (
            <select
              value={instalacionMeses}
              onChange={(e) => setInstalacionMeses(Number(e.target.value))}
            >
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <option key={n} value={n}>
                  {n} mes(es)
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="modal-buttons">
          <button className="btn-cancelar" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn-guardar" onClick={guardar}>
            Guardar Cliente
          </button>
        </div>
      </div>
      {toast && (
      <Toast
        mensaje={toast.mensaje}
        tipo={toast.tipo}
        onClose={() => setToast(null)}
      />
    )}
    </div>
  );
}

